import React from 'react';
import SongLinks from './SongLinks';
import cover from "../assets/coverart/fuehler.jpg"


export const Fuehler = () => {    

    return (
        <SongLinks 
        title={"Fühler"} 
        coverArt={cover} 
        spotifyLink={"https://open.spotify.com/album/0XFETmilPkSajwS24fevG6"}
        spotifyPresaveLink={"https://add-it.feiyr.com/zebrablau/F%C3%BChler"}
        appleMusicLink={"https://music.apple.com/de/album/f%C3%BChler-single/1830289550"} 
        appleMusicPresaveLink={undefined}
        youtubeMusicLink={"https://music.youtube.com/watch?v=E0vz4ei1yJc"}
        youtubeLink={undefined}
        tidalLink={"https://tidal.com/album/451462492"}
        amazonMusicLink={"https://www.amazon.com/F%C3%BChler/dp/B0FKPFWV3J"}
        bandcampLink={"https://mondwild.bandcamp.com/track/f-hler"}
        releaseDate={"2025-08-22T00:00:00+02:00"}/>
    );
}